export default __webpack_public_path__ + "static/media/Elvis_A02.32c5868f.mp4";